<template>
  <div class="cart-card">
    <b-skeleton
        size="is-large"
        height="162px"
        :active="!dispMounted && !loadedArticle"/>
    <div v-if="dispMounted" class="row align-items-center p-2">
      <div class="col-md-12">
        <div class="cod-art-prices">
          <p>{{ cod_art }} - <small>{{ currentArticle.des_art }}</small></p>

          <!-- descrizione articolo -->
        </div>
      </div>
      <div class="col-md-4">
        <price-elm :cod_art="cod_art" :current_user="currentUser" :unita_misura="currentArticle.unita_misura" @prezzi="fetchPrezzi"
                   @unita-misura="fetchUnitaMisura"/>
      </div>
      <div class="col-md-3">
        <p>{{ trans.get("b2b.article.quantity") }} ({{ unitaMisura }})</p>

        <div class="qta-selector">
          <b-field>
            <b-numberinput
                v-if="loadedArticle"
                :step="currentArticle.qta_per_imballo"
                controls-position="compact"
                :min="currentArticle.qta_per_imballo"
                size="is-small"
                v-model="innerQuantita"
                type="is-dark"
                :loading="inputLoading"
                            />
          </b-field>
        </div>
      </div>

      <div class="col-md-3">
        <div class="disp-qta">
          <p
              :class="
              disponibilita > 0
                ? 'disponibilita available'
                : 'disponibilita unavailable'
            "
          >
            <img
                :src="
                disponibilita > 0
                  ? url('/media/icons/available.svg')
                  : url('/media/icons/unavailable.svg')
              "
                :alt="disponibilita"
            />
            <span>{{ trans.get("b2b.article.availability") }} {{ disponibilita }} {{ unitaMisuraLong }}</span>

          </p>
        </div>
      </div>

      <div
          class="
          col-md-2
          d-flex
          cart-card-footer
          justify-content-around
          align-items-center
        "
      >
        <div class="sped-tot">
          <div class="total-price d-flex is-flex-direction-column justify-content-between">
            <p>{{ trans.get("b2b.cart.total") }}</p>
            <p>
              {{ totale.toLocaleString("it-IT", {minimumFractionDigits: 3}) }}
              €
            </p>
          </div>
        </div>
        <div class="tools align-self-center">
          <img
              :src="url('/media/icons/svg/deletecart.svg')"
              title="Rimuovi articolo"
              @click="confirmDestroy"
              alt="delete item"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "cart-card",
  props: ["cod_art", "quantita", "currentUser", "prezzo", "chiave"],
  mounted() {
    this.getGiacenza(this.cod_art);
    this.getArticleInfo(this.cod_art);
  },
  data() {
    return {
      inputLoading: null,
      disponibilita: null,
      dispMounted: false,
      currentArticle: null,
      loadedArticle: false,
      innerQuantita: this.quantita,
      totale: this.prezzo,
      prezzi: [],
      priceFound: null,
      unitaMisuraLong: null,
      unitaMisura: false,
    };
  },
  watch: {
    innerQuantita: function () {
      this.inputLoading = true
      setTimeout(() => {
        let prezzo = this.prezzi[0].prezzoNetto
        if (this.prezzi.length > 1) {
          length = this.prezzi.length
          if (this.innerQuantita < this.prezzi[length - 2].qta) { // < 99
            prezzo = this.prezzi[0].prezzoNetto
          } else if (this.innerQuantita >= this.prezzi[length - 2].qta && this.innerQuantita < this.prezzi[length - 1].qta) { // >= 100 < 499
            prezzo = this.prezzi[1].prezzoNetto
          } else if (this.innerQuantita >= this.prezzi[length - 1].qta) { // >= 500
            prezzo = this.prezzi[2].prezzoNetto
          }
        }
        this.totale = this.innerQuantita * prezzo;
        this.$store.dispatch("addItemToCart", {
          codart: this.cod_art,
          quantita: this.innerQuantita,
          prezzo: this.totale,
          prezzo_unitario: prezzo,
        });
        this.$emit("refreshTotCarrello", true);
        this.$emit("refreshImballo", true);
        this.inputLoading = false
      }, 350)
    },
    disponibilita: function () {
      if (this.disponibilita < 1) {
        this.$emit('disponibilita', false);
      }
    },
  },
  methods: {
    fetchUnitaMisura(values) {
      this.unitaMisura = values
      if (this.unitaMisura === 'Mt') {
        this.unitaMisuraLong = this.$trans('b2b.prices.meters')
      } else {
        this.unitaMisuraLong = this.$trans('b2b.prices.pieces')
      }
    },
    fetchPrezzi(values) {
      //console.log(values)
      this.priceFound = values.priceFound
      if (values.scaglioni !== null) {
        this.prezzi = values.scaglioni
      }
    },
    confirmDestroy() {
      this.$buefy.dialog.confirm({
        title: "Rimuovi Articolo",
        message: `Sei sicuro di voler rimuovere definitivamente
        l'articolo <strong>${this.cod_art}</strong> dal carrello?`,
        cancelText: "Annulla",
        confirmText: "Procedi",
        type: "is-danger",
        onConfirm: this.destroyItem,
      });
    },
    destroyItem: function () {
      this.$store.dispatch("deleteItemCart", {
        codart: this.cod_art,
      });
      //this.$store.dispatch("refreshCart");
    },
    getPathImage: function () {
      return (
          this.currentArticle.cod_macrofamiglia +
          "-" +
          this.currentArticle.cod_famiglia +
          "-" +
          this.currentArticle.cod_categoria +
          "-" +
          this.currentArticle.cod_colore +
          ".jpg"
      );
    },
    getPrices: function (codart, user) {
      axios({
        method: "post",
        url: window.location.origin + "/b2b/prezzi",
        params: {
          codart: codart,
          codcliente: user,
        },
      })
          .then((res) => {
            if (res.data[0].scaglioni.length !== 0) {
              this.prezzi = res.data[0].scaglioni;
            } else {
              this.prezzi.push({
                prezzoNetto: parseFloat("1"),
              });
            }
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    getGiacenza: function (codart) {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/giacenze",
        params: {
          codart: codart,
        },
      })
          .then((res) => {
            this.disponibilita = res.data[0].disponibilita;

            this.getPrices(this.cod_art, this.currentUser);


          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    getArticleInfo: function (codart) {
      axios({
        method: "get",
        url: window.location.origin + "/data/getArticleInfo",
        params: {
          codart: codart,
        },
      })
          .then((result) => {
            this.currentArticle = result.data.data;
            this.loadedArticle = true;
            this.dispMounted = true;
            this.$emit("loaded", this.chiave);
          })
          .catch((err) => {
            console.log(err.response.data.message);
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-card {
  font-size: 14px;
  width: 100%;

  background-color: #f5f5f5;
  margin: 1px 0;

  .row {
    [class^="col-"]:first-child {
      padding-left: 20px;
    }
  }

  .product-img {
    display: inline-block;
    height: 128px;
  }

  .tools {
    transform: scale(1.1);
    cursor: pointer;
  }

  .disp-qta {
    padding: 5px;
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;

    .disponibilita {
      img {
        display: inline-block;
        margin-right: 12px;
      }

      &.available {
        color: #23b371;
      }

      &.unavailable {
        color: #b32323;
      }
    }
  }

  .qta-selector {
    margin-top: 5px;
  }

  .cod-art-prices {
    padding: 14px 0;

    p {
      margin-bottom: 25px;
    }

    ul {
      font-size: 12px;

      li {
        display: flex;

        span {
          margin-left: auto;
        }
      }
    }
  }

  .total-price {
    padding: 14px 0;
  }

  .cart-card-footer {
    padding: 0;
  }
}
</style>
